import { PaymentMethod } from "../../data/Fleet/PaymentMethod";

export const repairFieldConfiguration = [
  {
    name: "estimatedCost",
    label: "Estimated Cost",
    type: "decimal",
    validation: {
      required: "Estimated cost is required",
      pattern: {
        value: /^\d+(\.\d{1,2})?$/,
        message: "Float number separated by dot and maximum 2 decimal places",
      },
    },
  },
  {
    name: "paymentMethod",
    label: "Payment Method",
    type: "select",
    options: PaymentMethod,
    validation: {
      required: "Payment method is required",
    },
  },
  {
    name: "authorizedBy",
    label: "Authorized By",
    type: "text",
    validation: {
      required: false,
    },
  },
];

export const repairInitialValues = {
  estimatedCost: "",
  paymentMethod: "",
  authorizedBy: "",
  finalCost: 0,
};
